import BaseAPI from '../base'

// 数据中心
class SystemService extends BaseAPI {

    upload(params, query, onUploadProgress) {
        return this.post({
            headers: {
                ContentType: 'multipart/form-data',
            },
            url: '/YuanHe/Work/WorkFileUploadStream',
            data: params,
            params: query,
            onUploadProgress,
        })
    }
}

export default new SystemService()